export default __webpack_public_path__ + "static/media/prime-kyc-logo.0881e503.svg";